import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { GroupsHelpers } from '../../service/GroupsHelpers/GroupsHelpers';
import { CampaignType, GroupType } from '../../typings/domain';
import { Shape2, Shape2Theme } from '../Shape2/Shape2';

type GridGroupTypeCellProps = {
    type: GroupType;
    campaignType: CampaignType;
};

export class GridGroupTypeCell extends React.Component<GridGroupTypeCellProps> {
    render() {
        const { type, campaignType } = this.props;

        return (
            <Shape2
                cls={Bem.cls('grid-type-cell', 'icon')}
                theme={Shape2Theme.light}
                icon={GroupsHelpers.getIconNameForGroupType(type, campaignType)}
                width={16}
                height={16}
                title={GroupsHelpers.getTitleForGroupType(type, campaignType)}
            />
        );
    }
}
